module.exports = __webpack_public_path__ + "images/fontello.eot";


//////////////////
// WEBPACK FOOTER
// ./~/mavon-editor/dist/font/fontello.eot
// module id = 375
// module chunks = 2